import React, { FC } from 'react';
import { TestimonialFragment } from '../types/graphqlTypes';
import { CardCarouselWrapper } from './CardCarouselWrapper';
import { Section } from './Section';
import { CardTestimonial } from './CardTestimonial';

interface TestimonialProps extends TestimonialFragment {
  width: 'narrow' | 'wide';
}

// JSX

export const Testimonial: FC<Omit<TestimonialProps, '__typename'>> = ({ title, backgroundColour, items, width }) => {
  if (items.length < 1) {
    return null;
  }

  const generateId = (text?: string) => text?.toLowerCase().replace(/[^a-zA-Z0-9]/g, '-');

  return (
    <Section
      contained
      background={backgroundColour || 'grey'}
      narrow={width !== 'wide'}
      overflowHidden
      id={generateId(title)}
    >
      <CardCarouselWrapper heading={title} width={width}>
        {items.map(({ name, text, audience }, index) => (
          <CardTestimonial key={index} text={text} name={name} audience={audience} />
        ))}
      </CardCarouselWrapper>
    </Section>
  );
};
